var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5H2V7H22V5ZM4 13H2V15H4V13ZM4 9H6V11H4V9ZM6 17H4V19H6V17ZM10 13H12V15H10V13ZM14 9H12V11H14V9ZM12 17H14V19H12V17ZM20 13H18V15H20V13ZM20 9H22V11H20V9ZM22 17H20V19H22V17ZM6 13H8V15H6V13ZM10 9H8V11H10V9ZM8 17H10V19H8V17ZM16 13H14V15H16V13ZM16 9H18V11H16V9ZM18 17H16V19H18V17Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/soil.d4b53d858efa9eee8fc410af7bf3d358.svg";